import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Progress } from "@/components/ui/progress";
import { Users, Mail, Phone, Building2 } from "lucide-react";

const STATUS_STYLES = {
  active: "bg-green-100 text-green-700",
  on_hold: "bg-yellow-100 text-yellow-700",
  completed: "bg-blue-100 text-blue-700"
};

export function ProjectCard({ project, onClick, hideCompany = false }) {
  return (
    <Card
      className="border-neutral-200 hover:border-emerald-300 transition-colors cursor-pointer"
      onClick={() => onClick(project)}
      data-testid={`project-card-${project.project_id}`}
    >
      <CardContent className="p-5">
        <div className="flex items-start justify-between mb-3">
          <Badge variant="outline" className="text-xs">{project.project_type}</Badge>
          <Badge className={STATUS_STYLES[project.status] || "bg-gray-100"}>
            {project.status?.replace("_", " ").toUpperCase()}
          </Badge>
        </div>
        <h3 className="font-semibold text-neutral-900 mb-1">{project.title}</h3>
        <div className="flex items-center gap-2 text-sm text-neutral-500 mb-0.5">
          <Users className="w-3.5 h-3.5" />
          <span>{project.client?.name || "Unknown Client"}</span>
        </div>
        {project.client?.email && (
          <div className="flex items-center gap-1.5 text-[11px] text-neutral-400 mb-1 flex-wrap">
            <Mail className="w-3 h-3" />
            <a href={`mailto:${project.client.email}`} className="hover:text-emerald-600 hover:underline" onClick={e => e.stopPropagation()}>{project.client.email}</a>
            {project.client?.phone && <>
              <span className="text-neutral-300">|</span>
              <Phone className="w-3 h-3" />
              <a href={`tel:${project.client.phone}`} className="hover:text-emerald-600 hover:underline" onClick={e => e.stopPropagation()}>{project.client.phone}</a>
            </>}
          </div>
        )}
        {project.company_name && !hideCompany && (
          <div className="flex items-center gap-2 text-xs text-blue-600 mb-2">
            <Building2 className="w-3 h-3" />
            <span>{project.company_name}</span>
          </div>
        )}
        {!project.company_name && !hideCompany && (
          <div className="flex items-center gap-2 text-xs text-neutral-400 mb-2">
            <Building2 className="w-3 h-3" />
            <span>No company</span>
          </div>
        )}
        <div className="space-y-2 mt-2">
          <div className="flex justify-between text-sm">
            <span className="text-neutral-500">Progress</span>
            <span className="font-medium">{project.percentage_complete || 0}%</span>
          </div>
          <Progress value={project.percentage_complete || 0} className="h-2" />
        </div>
      </CardContent>
    </Card>
  );
}
